/* Fonts
-------------------------------------------------- */

import "@fontsource/open-sans" // Defaults to weight 400 with all styles included.
import "@fontsource/andada-pro" // Defaults to weight 400.
import "@fontsource/noto-sans-display" // Defaults to weight 400.

/* AppĈontainer
-------------------------------------------------- */

import React from "react"

import AppContainer from "./src/components/AppContainer/AppContainer"

export function wrapPageElement({ element, props }) {
  return <AppContainer {...props}>{element}</AppContainer>
}
